import { channelIdFrom } from './useIngestRequest'

// The service takes a YouTube channel id and nothing else
// (content-admin/ingest/src/input.js artistSourceId). Everything a person
// might paste has to reduce to one, or be refused with a reason we can
// explain - a request filed with anything else is rejected server-side.

describe('what the ingest service will accept', () => {
  test('a bare UC channel id goes straight through', () => {
    expect(channelIdFrom('UCy9EQSb0ZVgrP2xhBpCvKvQ')).toEqual({
      ok: true,
      channelId: 'UCy9EQSb0ZVgrP2xhBpCvKvQ',
    })
  })

  test('a channel URL has its id pulled out', () => {
    for (const url of [
      'https://www.youtube.com/channel/UCy9EQSb0ZVgrP2xhBpCvKvQ',
      'https://music.youtube.com/channel/UCy9EQSb0ZVgrP2xhBpCvKvQ',
      'https://music.youtube.com/browse/UCy9EQSb0ZVgrP2xhBpCvKvQ',
    ]) {
      expect(channelIdFrom(url).channelId).toBe('UCy9EQSb0ZVgrP2xhBpCvKvQ')
    }
  })

  test('whitespace and invisible paste characters do not break it', () => {
    expect(channelIdFrom('  https://www.youtube.com/channel/UCy9EQSb0ZVgrP2xhBpCvKvQ  ').ok).toBe(true)
  })

  test('an @handle is refused, because the service cannot look one up', () => {
    // A perfectly good identifier - just not one this endpoint takes. The
    // reason is specific so the screen can say what to copy instead.
    const out = channelIdFrom('https://www.youtube.com/@sabrinacarpenter')
    expect(out.ok).toBe(false)
    expect(out.reason).toBe('needs_channel_id')
  })

  test('a FAST artist link is refused for the same reason', () => {
    expect(channelIdFrom('https://fast.feelsmusic.app/artist/sabrina-carpenter').reason).toBe(
      'needs_channel_id'
    )
  })

  test('a song or album link is refused as the wrong kind of thing', () => {
    expect(channelIdFrom('https://www.youtube.com/watch?v=dQw4w9WgXcQ').reason).toBe('not_an_artist')
    expect(channelIdFrom('https://music.youtube.com/playlist?list=OLAK5uy_abcdef').reason).toBe(
      'not_an_artist'
    )
  })

  test('empty input is its own reason, not a parse failure', () => {
    expect(channelIdFrom('').reason).toBe('empty')
    expect(channelIdFrom('   ').reason).toBe('empty')
    expect(channelIdFrom(null).reason).toBe('empty')
  })

  test('a half-typed channel id is called incomplete, not a name', () => {
    // It has capitals and no punctuation, so the resolver reads it as prose.
    // Telling someone mid-paste that their channel id "looks like a name" is
    // both wrong and unhelpful.
    for (const partial of ['UCtooshort', 'UCy3zgWom-5AGypGX_FVTKp', 'UC']) {
      const out = channelIdFrom(partial)
      expect(out.ok).toBe(false)
      expect(out.reason).toBe('partial_channel_id')
    }
  })

  test('one more character makes it valid', () => {
    expect(channelIdFrom('UCy3zgWom-5AGypGX_FVTKpg').ok).toBe(true)
  })
})
